export default __webpack_public_path__ + "static/media/partner-phantom-galaxies.7ea2ca42.png";